// Wrapper around react-lazyload that can be short-circuited for testing

import PropTypes from 'prop-types';
import React from 'react';
import ReactLazyLoad from 'react-lazyload';

function LazyLoad({ children, ...props }) {
  if (LazyLoad.disabled) {
    return children;
  }

  return (
    <ReactLazyLoad debounce={50} offset={1000} unmountIfInvisible {...props}>
      {children}
    </ReactLazyLoad>
  );
}

LazyLoad.propTypes = {
  children: PropTypes.node.isRequired,
};

LazyLoad.disabled = false;

export default LazyLoad;
